import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const TextBoxStyles = styled.div`
  width: auto;
  display: flex;
  overflow: hidden;
  min-width: 52.25rem;
  min-height: auto;
  border-radius: 0.375rem;
  box-shadow: ${CONFIG.theme.shadows.default};
  ${CONFIG.media.mobileLg} {
    min-width: 95vw;
    flex-direction: column-reverse;
    border-radius: 0;
    box-shadow: none;
  }
`

export const TextBox = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
  padding: 1.5rem;

  ${CONFIG.media.mobileLg} {
    width: 100%;
    padding: 0.5rem;
    margin-top: 0.5rem;

    .media-text-box__heading {
      text-align: center;
    }
  }
`

export const MediaWrapper = styled.div`
  width: 100%;
  span {
    flex-shrink: 0;
    min-width: 100%;
    min-height: 100%;
  }

  img {
    object-fit: cover;
  }

  ${CONFIG.media.mobileLg} {
    display: block;
    margin: 0 auto;
  }
`
